import * as z from "zod";

import { issueSchema } from "./issue";
import { issueWithCreatedByAndLinksSchema } from "./issue-with-created-by-and-links";

export const issueWithCreatedByAndLinksAndChildrenAndParentSchema =
  issueWithCreatedByAndLinksSchema.extend({
    parent: issueSchema.optional(),
    children: z.array(issueSchema),
  });

export type IssueWithCreatedByAndLinksAndChildrenAndParent = z.infer<
  typeof issueWithCreatedByAndLinksAndChildrenAndParentSchema
>;
